import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllSubjects({ payload }) {
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.getAllSubjects);
    yield put(actions.getAllSubjectsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllSubjectsFail());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

//Edit Tables
function* editSubject({ payload }) {
  console.log(payload, "pa");
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.editSubjects, payload);
    console.log(result, "res");
    yield put(actions.editSubjectSuccess(result.data));
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.editSubjectFail());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

function* restrictSubject({ payload }) {
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.restrictSubjects, payload);
    yield put(actions.restrictSubjectSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.restrictSubjectFail());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

function* asqueraSubject({ payload }) {
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.asquaraSubjects, payload);
    yield put(actions.asqueraSubjectSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.asqueraSubjectFail());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

function* activeSubject({ payload }) {
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.activeSubjects, payload);
    yield put(actions.activeSubjectSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.activeSubjectFail());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

// create
function* createSubject(formData) {
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.createSubjects, formData.payload);
    yield put(
      actions.createSubjectSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action();
  } catch (error) {
    yield put(actions.createSubjectFail());
    toast.success(error.data.message.toString());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

function* deleteSubject({ payload }) {
  try {
    yield put(actions.addSubjectLoading(true));
    const result = yield call(api.deleteSubject, payload);

    yield put(actions.deleteSubjectSuccess(payload));

    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deleteSubjectFail());
  } finally {
    yield put(actions.addSubjectLoading(false));
  }
}

export default function* SuperadminSubjectSaga() {
  yield takeLatest(Types.GET_SUPERADMIN_SUBJECTS_REQUEST, getAllSubjects);
  yield takeLatest(Types.EDIT_SUPERADMIN_SUBJECT_REQUEST, editSubject);
  yield takeLatest(Types.RESTRICT_SUPERADMIN_SUBJECT_REQUEST, restrictSubject);
  yield takeLatest(Types.ACTIVE_SUPERADMIN_SUBJECT_REQUEST, activeSubject);
  yield takeLatest(Types.ASQUARA_SUPERADMIN_SUBJECT_REQUEST, asqueraSubject);

  yield takeLatest(Types.CREATE_SUPERADMIN_SUBJECT_REQUEST, createSubject);
  yield takeLatest(Types.DELETE_SUPERADMIN_SUBJECT_REQUEST, deleteSubject);
}
